import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Auth from '../views/Auth.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Auth",
    component: Auth,
    meta: {
      requiresAuth: false,
      breadCrumb: "Auth",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
      breadCrumb: "Home",
    },
  },
  {
    path: "/facility/:facilityName",
    name: "Facility",
    component: () =>
      import(/* webpackChunkName: "config" */ "../views/FacilityCode.vue"),

    meta: {
      requiresAuth: true,
      breadCrumb: "Facility",
    },
  },
  {
    path: "/qareview/",
    name: "QA Review",
    component: () =>
      import(/* webpackChunkName: "config" */ "../views/QAReview.vue"),

    meta: {
      requiresAuth: true,
      breadCrumb: "QA Review",
    },
  },
  {
    path: "/qareviewdirect/:client/:facility/:encid",
    name: "QA Review Direct",
    component: () =>
      import(/* webpackChunkName: "config" */ "../components/QAReviewDirect.vue"),

    meta: {
      requiresAuth: true,
      breadCrumb: "QA Review Direct",
      popout: true,
      full:true
    },
  },
  {
    path: "/blank",
    name: "Blank",
    component: () =>
      import(/* webpackChunkName: "config" */ "../components/blank.vue"),

    meta: {
      requiresAuth: true,
      breadCrumb: "Blank",
      popout: true,
      full:true
    },
  },
  {
    path: '/mobile',
    name: 'Mobile',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/Mobile.vue'),
    meta: {
      requiresAuth: false,
      breadCrumb: "Mobile",
    },
  },
  {
    path: "/popoutpdfviewer",
    name: "PopoutPDFViewer",
    component: () =>
      import(/* webpackChunkName: "PopoutPDFViewer" */ "../views/PopoutPDFViewer.vue"),
    meta: {
      breadCrumb: "PopoutPDFViewer",
      popout: true,
    },
  },
  {
    path: "/enhancedpopoutpdfviewer",
    name: "EnahncedPopoutPDFViewer",
    component: () =>
      import(/* webpackChunkName: "PopoutPDFViewer" */ "../views/EnahncedPopoutPDFViewer.vue"),
    meta: {
      breadCrumb: "EnahncedPopoutPDFViewer",
      popout: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
      next();
    } catch (e) {
      next({
        path: "/",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  next();
});


export default router
